export const MODE_BUTTON_CLICKED = "mode_button_clicked";
